<div class="row" *ngIf="model && model.data && model.data.toString() !== ''">
  <div class="col-sm-4 data-label">
    {{ model.label }}
  </div>
  <div class="col-auto">
    {{ model.data }}
  </div>
</div>